import * as CONTEXT from '../../../../../shared/constants/analytics/contexts';

export const ADS_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/ads/analytics/report`,
  TRENDS: `/v1/ads/analytics/trends`,
  TOTALS: `/v1/ads/analytics/totals`,
};

export const ROI_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/roi/analytics/report`,
  TOTALS: `/v1/roi/analytics/totals`,
};

export const SEO_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/seo/analytics/report`,
  TRENDS: `/v1/seo/analytics/trends`,
  TOTALS: `/v1/seo/analytics/totals`,
};

export const QR_CODE_LINK_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/qr-code-link/analytics/report`,
  TRENDS: `/v1/qr-code-link/analytics/trends`,
  TOTALS: `/v1/qr-code-link/analytics/totals`,
};

export const SKAN_UNIFIED_ANALYTICS_ENDPOINT = {
  REPORT: `/v2/unified-skan/analytics/report`,
  TOTALS: `/v2/unified-skan/analytics/totals`,
};

export const SOURCES_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/sources/analytics/report`,
  TOTALS: `/v1/sources/analytics/totals`,
};

export const OTT_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/ott/analytics/report`,
  TRENDS: `/v1/ott/analytics/trends`,
  TOTALS: `/v1/ott/analytics/totals`,
  WIDGETS: `/v1/ott/analytics/widgets`,
};

export const JOURNEYS_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/journeys/analytics/report`,
  TRENDS: `/v1/journeys/analytics/trends`,
  TOTALS: `/v1/journeys/analytics/totals`,
};

export const EMAILS_ANALYTICS_ENDPOINT = {
  REPORT: '/v1/emails/analytics/report',
  TRENDS: `/v1/emails/analytics/trends`,
  TOTALS: '/v1/emails/analytics/totals',
};

export const SUMMARY_ANALYTICS_ENDPOINT = {
  REPORT: '/v1/summary/analytics/report',
  TRENDS: `/v1/summary/analytics/trends`,
  TOTALS: '/v1/summary/analytics/totals',
};

export const QUICK_LINKS_ANALYTICS_ENDPOINT = {
  REPORT: '/v1/quick-links/analytics/report',
  TRENDS: `/v1/quick-links/analytics/trends`,
  TOTALS: '/v1/quick-links/analytics/totals',
};

export const ANALYTICS_REPORT_ENDPOINT_BY_CONTEXT = {
  [CONTEXT.ADS_TABLE]: ADS_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.SEO_TABLE]: SEO_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.QR_CODE_LINK_TABLE]: QR_CODE_LINK_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.SKAN_UNIFIED_TABLE]: SKAN_UNIFIED_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.SOURCES_TABLE]: SOURCES_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.OTT_TABLE]: OTT_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.JOURNEYS_TABLE]: JOURNEYS_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.JOURNEYS_HISTORY_TABLE]: JOURNEYS_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.EMAILS_TABLE]: EMAILS_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.SUMMARY_TABLE]: SUMMARY_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.QUICK_LINKS_TABLE]: QUICK_LINKS_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.ROI_ANALYTICS_TABLE]: ROI_ANALYTICS_ENDPOINT.REPORT,
} as const;

export const ANALYTICS_TRENDS_ENDPOINT_BY_CONTEXT = {
  [CONTEXT.ADS_TRENDS]: ADS_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.SEO_TRENDS]: SEO_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.QR_CODE_LINK_TRENDS]: QR_CODE_LINK_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.OTT_TRENDS]: OTT_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.JOURNEYS_TRENDS]: JOURNEYS_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.EMAILS_TRENDS]: EMAILS_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.SUMMARY_TRENDS]: SUMMARY_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.QUICK_LINKS_TRENDS]: QUICK_LINKS_ANALYTICS_ENDPOINT.TRENDS,
} as const;

export const ANALYTICS_REPORT_TOTALS_ENDPOINT_BY_CONTEXT = {
  [CONTEXT.ADS_TABLE]: ADS_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.SEO_TABLE]: SEO_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.QR_CODE_LINK_TABLE]: QR_CODE_LINK_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.SKAN_UNIFIED_TABLE]: SKAN_UNIFIED_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.SOURCES_TABLE]: SOURCES_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.OTT_TABLE]: OTT_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.JOURNEYS_TABLE]: JOURNEYS_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.EMAILS_TABLE]: EMAILS_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.SUMMARY_TABLE]: SUMMARY_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.QUICK_LINKS_TABLE]: QUICK_LINKS_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.ROI_ANALYTICS_TABLE]: ROI_ANALYTICS_ENDPOINT.TOTALS,
} as const;

export const ANALYTICS_ENDPOINT_BY_CONTEXT = {
  ...ANALYTICS_REPORT_ENDPOINT_BY_CONTEXT,
  ...ANALYTICS_TRENDS_ENDPOINT_BY_CONTEXT,
} as const;
